export default __webpack_public_path__ + "static/broadcastImg1-58d994173640489ea76a0514e5742efe.webp";